'use strict';

var _ = require('lodash');
var BookingsIntakeSerializerService = function BookingsIntakeSerializerService() {
  var BOOKINGS_INTAKE = 'Bookings Intake';
  var DAYS_OFFSET_DETERMINING_PART = '.daysOffsets(';
  var BOOKINGS_INTAKE_PERCENT = 'Bookings Intake %';
  var DAYS_OFFSET_PERCENT_DETERMINING_PART = '.daysOffsetsInPercent(';
  function isBookingsIntakeCriterion(criterion) {
    return criterion === BOOKINGS_INTAKE;
  }
  function isBookingsIntakePercentCriterion(criterion) {
    return criterion === BOOKINGS_INTAKE_PERCENT;
  }
  function isBookingsIntakeByOperandValue(operandValue) {
    return _.isString(operandValue) && operandValue.indexOf(DAYS_OFFSET_DETERMINING_PART) !== -1;
  }
  function isBookingsIntakePercentByOperandValue(operandValue) {
    return _.isString(operandValue) && operandValue.indexOf(DAYS_OFFSET_PERCENT_DETERMINING_PART) !== -1;
  }
  function getDomainFromField(fieldName) {
    return fieldName.substring(0, fieldName.indexOf('.'));
  }
  function serialize(fieldName, functionType) {
    return getDomainFromField(fieldName) + '.daysOffsets(\'' + functionType + '\')';
  }
  function serializePercent(fieldName, functionType) {
    return getDomainFromField(fieldName) + '.daysOffsetsInPercent(\'' + functionType + '\')';
  }
  function deserialize(condition) {
    var selector = condition.selector.match(/'([^']*)'/g);
    var arg = condition.arguments[0];
    return {
      functionType: selector[0].replace(/'/g, ''),
      leftOperand: arg
    };
  }
  return {
    BOOKINGS_INTAKE: BOOKINGS_INTAKE,
    BOOKINGS_INTAKE_PERCENT: BOOKINGS_INTAKE_PERCENT,
    isBookingsIntakeCriterion: isBookingsIntakeCriterion,
    isBookingsIntakePercentCriterion: isBookingsIntakePercentCriterion,
    isBookingsIntakeByOperandValue: isBookingsIntakeByOperandValue,
    isBookingsIntakePercentByOperandValue: isBookingsIntakePercentByOperandValue,
    serialize: serialize,
    serializePercent: serializePercent,
    deserialize: deserialize
  };
};
BookingsIntakeSerializerService.$inject = [];
module.exports = BookingsIntakeSerializerService;